// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const collapsibleClasses = {
  content: "qui-collapsible__content",
} as const
